import React from 'react';
import { useTranslation } from 'react-i18next';

import StandardLayoutCommon from '#web-components/components/Layouts/Standard';
import LogoLink from '#web-components/components/Navbar/components/LogoLink';

import LoaderIcon from 'components/LoaderImage';
import LogoIcon from 'components/LogoImage';

import ExternalLink from '../ExternalLink';

interface Props {
  title: string;
  children?: React.ReactNode;
  description?: string;
  isLoading?: boolean;
}

export default function StandardLayout({
  title,
  description,
  isLoading = false,
  children,
}: Props) {
  const { t } = useTranslation();
  const backLinkPath = FTL_PARAMS.startPageUrl;
  const registryTitle = FTL_PARAMS.title;
  const registryTitleFull = FTL_PARAMS.titleFull;

  return (
    <StandardLayoutCommon
      t={t}
      title={title}
      description={description}
      registryName={registryTitle}
      registryFullName={registryTitleFull}
      backLink={{
        title: t('backLinkCaption'),
        path: backLinkPath,
        RouterNavLink: ExternalLink,
      }}
      isLoading={isLoading}
      loaderIcon={<LoaderIcon />}
      sidebar={{
        logo: <LogoLink
          appTitle={t('appTitle')}
          homePath={backLinkPath}
          navLinkComponent={ExternalLink}
          logoIcon={<LogoIcon />}
        />,
      }}
      supportChannelUrl={FTL_PARAMS.supportChannelUrl}
    >
      {children}
    </StandardLayoutCommon>
  );
}
